/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

/**
 * @description Request to fetch multiple items by ID with field projection
 */
export const bulkFetchV2RequestSchema = z
  .object({
    customFieldIds: z
      .array(z.int())
      .describe('Custom field IDs to include. Only used when `customFields` is in `fieldIds`.')
      .nullish(),
    fieldIds: z
      .array(z.string())
      .describe(
        'List of field names to include in the response. If null or omitted, only `id` is returned.\n\n**Item fields:**\n- `id`\n- `name`\n- `description`\n- `itemTypeId`\n- `itemStatusId`\n- `parentId`\n- `schedulingType`\n- `teamId`\n- `earliestStartDateTime`\n- `deadlineDateTime`\n- `plannedStartDateTime`\n- `plannedFinishDateTime`\n- `doneDateTime`\n- `timeSpentSeconds`\n- `priority`\n- `externalKey`\n- `externalLink`\n- `externalCreatedAt`\n- `parentManagedByIntegration`\n- `loopId`\n- `estimationId`\n- `createdAt`\n- `updatedAt`\n- `createdBy`\n- `updatedBy`\n\n**Enrichment fields (opt-in, fetched from related services):**\n- `dependencies` — item dependency relationships\n- `customFields` — custom field values (use with `customFieldIds` to select specific fields)\n- `schedules` — expected/latest start and finish datetimes\n- `estimationSchema` — estimation details (label, effort, scheme)\n',
      )
      .nullish(),
    ids: z.array(z.int()).describe('Item IDs to fetch'),
  })
  .describe('Request to fetch multiple items by ID with field projection');
